import React from 'react';
import { Card, Accordion } from 'react-bootstrap';

export default function Step7Pleated({
  ContextAwareToggle,
  requiredStep,
  stepSelectedLabel,
  setDeps,
  setCart,
  t,
  step5,
  setStep5,
  selectChanged,
  inputs,
  NextStep,
  pageLanguage,
  step2B
}) {
  return (
   <Card>
   <Card.Header>
     <ContextAwareToggle
       eventKey="5"
       stepNum={t("7")}
       stepTitle={t("grommet_step5_Drapery")}
       stepRef="5"
       type="1"
       required={requiredStep["5"]}
       stepSelected={stepSelectedLabel["5"] === undefined ? "" : stepSelectedLabel["5"]}
     />
   </Card.Header>
   <Accordion.Collapse eventKey="5">
     <Card.Body>
       <div className="card_body card_body_radio tall_img_card_body">
         <div className="box50 radio_style">
           <input
             className="radio"
             type="radio"
             text={t("Full")}
             value="1"
             name="step5"
             ref-num="5"
             id="51"
             checked={step5 === "Full"}
             onChange={(e) => {
               setStep5("Full");
               if(step2B === "None"){
                setDeps("6A,6B", "5,6");
               }else{
                setDeps("6A,6B,6C", "5,6");
               }
               
               setCart("PanelCoverage", "Full");
               selectChanged(e);
             }}
             ref={(ref) => (inputs.current["51"] = ref)}
           />
           <label htmlFor="51">{t("Full")}</label>
         </div>
         <div className="box50 radio_style">
           <input
             className="radio"
             type="radio"
             text={t("Decorative")}
             value="2"
             name="step5"
             ref-num="5"
             id="52"
             checked={step5 === "Decorative"}
             onChange={(e) => {
               setStep5("Decorative");
               if(step2B === "None"){
                setDeps("6A,6B", "5,6");
               }else{
                setDeps("6A,6B,6C", "5,6");
               }
               setCart("PanelCoverage", "Decorative");
               selectChanged(e);
             }}
             ref={(ref) => (inputs.current["52"] = ref)}
           />
           <label htmlFor="52">{t("Decorative")}</label>
         </div>

         <NextStep currentStep="5" eventKey="6">
           {t("NEXT STEP")}
         </NextStep>
       </div>
       <div className="accordion_help">
         <div className="help_container">
           <div className="help_column help_left_column">
             <p className="help_column_header">{t("grommet_panel_help_3")}</p>
             <ul className="help_column_list">
               <li>{t("grommet_panel_help_4")}</li>
             </ul>
           </div>
           <div className="help_column help_right_column">
             <p className="help_column_header">{t("grommet_panel_help_1")}</p>
             <ul className="help_column_list">
               <li>{t("grommet_panel_help_2.5")}</li>
               <li>{t("grommet_panel_help_2")}</li>
             </ul>
           </div>
         </div>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
